import React from 'react';
import { TableCell, TableHeader, TableRow } from '@/components/ui/Table';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';
import COLUMN_WIDTHS from './columns';

// tw-font-bold is explicit because TableCell's header variant sets semibold.
const HEADER_TEXT = 'tw-text-left tw-text-sm tw-font-bold tw-text-very-dark-grey';

// Sticky goes on the cells, not the row — a sticky <tr> is ignored by some engines, a sticky <th>
// isn't — so each cell carries the header background or the rows show through it.
const STICKY_HEADER = 'tw-sticky tw-top-0 tw-z-10 tw-bg-light-grey';

interface TagManagerTableHeaderProps {
  allSelected: boolean;
  hasSelectableRows: boolean;
  selectAllRef: React.RefObject<HTMLInputElement>;
  onToggleSelectAll: () => void;
}

const TagManagerTableHeader = ({
  allSelected, hasSelectableRows, selectAllRef, onToggleSelectAll,
}: TagManagerTableHeaderProps) => (
  <TableHeader>
    <TableRow className="tw-bg-light-grey tw-border-b tw-border-solid tw-border-light-grey">
      <TableCell header className={cn(COLUMN_WIDTHS.select, STICKY_HEADER, 'tw-px-2')}>
        <input
          ref={selectAllRef}
          aria-label={I18n.t('select_all')}
          checked={allSelected}
          disabled={!hasSelectableRows}
          type="checkbox"
          onChange={onToggleSelectAll}
        />
      </TableCell>
      <TableCell header className={cn(COLUMN_WIDTHS.standard, STICKY_HEADER, HEADER_TEXT)}>
        {I18n.t('standard')}
      </TableCell>
      <TableCell header className={cn(COLUMN_WIDTHS.description, STICKY_HEADER, HEADER_TEXT)}>
        {I18n.t('description')}
      </TableCell>
      <TableCell header className={cn(COLUMN_WIDTHS.source, STICKY_HEADER, HEADER_TEXT)}>
        {I18n.t('source')}
      </TableCell>
      <TableCell header className={cn(COLUMN_WIDTHS.remove, STICKY_HEADER, 'tw-px-0')} />
    </TableRow>
  </TableHeader>
);

export default TagManagerTableHeader;
